<nz-rate [ngModel]="rating" nzDisabled class="nz-rating-sec"></nz-rate>
